module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-mask-6.c9ddba8d.png";